/**
 * A fresh Idempotency-Key for one create. Generate it when the form OPENS and
 * keep it until the create succeeds: a timed-out Submit pressed again then
 * sends the same key, and the API answers with the post the first press made
 * instead of creating a second (backend `createPostOnce`).
 */
export const newIdempotencyKey = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};
